import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/audioRecording.tsx
var AudioRecording = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M7.75 3.75V20.25M3.75 9.75V14.25M12 7.75V16.25M16.25 5.75V18.25M20.25 9.75V14.25",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M8.5 3.75C8.5 3.33579 8.16421 3 7.75 3C7.33579 3 7 3.33579 7 3.75V20.25C7 20.6642 7.33579 21 7.75 21C8.16421 21 8.5 20.6642 8.5 20.25V3.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M17 5.75C17 5.33579 16.6642 5 16.25 5C15.8358 5 15.5 5.33579 15.5 5.75V18.25C15.5 18.6642 15.8358 19 16.25 19C16.6642 19 17 18.6642 17 18.25V5.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.75 7.75C12.75 7.33579 12.4142 7 12 7C11.5858 7 11.25 7.33579 11.25 7.75V16.25C11.25 16.6642 11.5858 17 12 17C12.4142 17 12.75 16.6642 12.75 16.25V7.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M4.5 9.75C4.5 9.33579 4.16421 9 3.75 9C3.33579 9 3 9.33579 3 9.75V14.25C3 14.6642 3.33579 15 3.75 15C4.16421 15 4.5 14.6642 4.5 14.25V9.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21 9.75C21 9.33579 20.6642 9 20.25 9C19.8358 9 19.5 9.33579 19.5 9.75V14.25C19.5 14.6642 19.8358 15 20.25 15C20.6642 15 21 14.6642 21 14.25V9.75Z",
			fill: "currentColor"
		})
	] })
});
//#endregion
export { AudioRecording };
